module.exports = __webpack_public_path__ + "75589dd64f6cfeb6ee60546e135511d0.svg";